import { render, staticRenderFns } from "./ekkos.vue?vue&type=template&id=5526e4d5&scoped=true&"
import script from "./ekkos.vue?vue&type=script&lang=js&"
export * from "./ekkos.vue?vue&type=script&lang=js&"
import style0 from "./ekkos.vue?vue&type=style&index=0&id=5526e4d5&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5526e4d5",
  null
  
)

export default component.exports